"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Button_1 = require("../../components/Button");
const Icon_1 = require("../../components/Icon");
const Card_1 = require("../../components/Card");
const sidebarUtils_1 = require("./utils/sidebarUtils");
// styles
require("./sidebarBSSPlatformTools.scss");
const defaultProps = {
    className: "tecma-SidebarBSSPlatformTools",
    id: undefined,
    style: undefined,
    "data-testid": "tecma-SidebarBSSPlatformTools",
    onLinkClick: sidebarUtils_1.goTo,
    onCardClick: sidebarUtils_1.onCardClick,
};
const SidebarBSSPlatformTools = (_a) => {
    var { tools, imagesBaseUrl, bssPlatformLink, currentTool, labels, onLinkClick, onCardClick } = _a, rest = __rest(_a, ["tools", "imagesBaseUrl", "bssPlatformLink", "currentTool", "labels", "onLinkClick", "onCardClick"]);
    const { className } = rest, props = __rest(rest, ["className"]);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "tecma-SidebarBSSPlatformTools" }, props, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "sidebarBSSPlatformTools-header" }, { children: [labels.title, (0, jsx_runtime_1.jsxs)(Button_1.Button, Object.assign({ className: "sidebarBSSPlatformTools-redirect-button", onClick: () => {
                            if (onLinkClick) {
                                onLinkClick(bssPlatformLink);
                            }
                        } }, { children: [labels.bssPlatform, (0, jsx_runtime_1.jsx)(Icon_1.Icon, { iconName: "exit", className: "sidebarBSSPlatformTools-redirect-button-icon", size: "extra-small" })] }))] })), tools.map((tool) => ((0, jsx_runtime_1.jsxs)(Card_1.Card, Object.assign({ className: "sidebarBSSPlatformTools-toolBox", orientation: "horizontal", selected: tool.name === currentTool, setSelected: () => {
                    if (onCardClick) {
                        onCardClick(tool.name, currentTool, tool.url);
                    }
                } }, { children: [(0, jsx_runtime_1.jsx)(Card_1.Card.Media, Object.assign({ className: "sidebarBSSPlatformTools-card-media-override" }, { children: (0, jsx_runtime_1.jsx)("img", { src: `${imagesBaseUrl}/${tool.name.toLowerCase()}.jpeg?v=${new Date().getDay()}`, alt: `${tool.name.toLowerCase()}`, className: "sidebarBSSPlatformTools-toolImage" }) })), (0, jsx_runtime_1.jsx)(Card_1.Card.Content, Object.assign({ className: "sidebarBSSPlatformTools-toolName" }, { children: tool.name }))] }), tool.name)))] })));
};
SidebarBSSPlatformTools.defaultProps = defaultProps;
exports.default = SidebarBSSPlatformTools;
